import { render, staticRenderFns } from "./TestToken.vue?vue&type=template&id=880c3612&scoped=true&"
import script from "./TestToken.vue?vue&type=script&lang=js&"
export * from "./TestToken.vue?vue&type=script&lang=js&"
import style0 from "./TestToken.vue?vue&type=style&index=0&id=880c3612&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880c3612",
  null
  
)

export default component.exports